module.exports = "@page {\n  size: landscape;\n  margin: 0; }\n\n@media print {\n  .ListTable {\n    display: none; } }\n"